import React,{ Component } from 'react';
// import {Link} from 'react-router';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';

export default class Web_Shipping_Status extends Component{
	componentDidMount()
	{
		if(screen.width < 800)
		{
			window.location.href="/payment_status/"+this.props.params.Status;
		}
	}
	render(){
		document.title="Payment Status | AquaDeals";
		var status_title =<div><h4>Something went wrong</h4><a href="/web/home" className="web_expl_btn">Explore Deals</a></div>;
		if(this.props.params.Status === 'aborted')
		{
			status_title =<div><h4>Transaction Aborted</h4><a href="/web/home" className="web_expl_btn">Explore Deals</a></div>;
		}
		else if(this.props.params.Status==='success')
		{
			if(this.props.params.OrderType && this.props.params.Oid)
			{
				status_title =<div><i><img src="https://aquadeals.in/admin/assets/icons/web_icons/conformed.png" width="70px" alt=""/></i><h5 style={{marginTop:'10px',marginBottom:'30px'}}>Shipping Payment Completed Successfully</h5><a href={'/web/order_details/'+this.props.params.OrderType+'/'+this.props.params.Oid}>View Order Details</a></div>;	
			}
			else
			{
				status_title =<div><i><img src="https://aquadeals.in/admin/assets/icons/web_icons/conformed.png" width="70px" alt=""/></i><h5 style={{marginTop:'10px',marginBottom:'30px'}}>Shipping Payment Completed Successfully</h5><a href={'/web/home'}>Explore Deals</a></div>;
			}
		}
		else if(this.props.params.Status ==='failure')
		{
			status_title =<div><h4>Transaction Failed</h4><a href="/web/home" className="web_expl_btn">Explore Deals</a></div>;
		}
		else if(this.props.params.Status ==='invalid')
		{
			status_title =<div><h4>Invalid Transaction</h4><a href="/web/home" className="web_expl_btn">Explore Deals</a></div>;
			
		}
		else if(this.props.params.Status === 'serverDown')
		{
			status_title=<div><h4>Server Down</h4><a href="/web/home" className="web_expl_btn">Explore Deals</a></div>
		}
		else
		{
			status_title =<div><h4>Something went wrong !</h4><a href="/web/home" className="web_expl_btn">Explore Deals</a></div>;
		}
		return(
			<div className="web_deals web_shipping_status_page">
			    <WebHeaderInner />
		        <div className="clr">&nbsp;</div>
		        <div className="clr">&nbsp;</div>
			    <section className="container">
					<div className="row">
						<div className="col-md-6 col-md-offset-3 web_dels_cntnt">
							<div className="web_abort_content">
								{status_title ? status_title : <h4>Something went wrong</h4>}
								{/*<a href="/web/home">Explore Deals</a>*/}
							</div>
						</div>
					</div>
				</section>
			    <WebFooter />
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Orders/Web_Shipping_Status.js
 **/